import { OnInit, Component, ViewChild, ElementRef } from "@angular/core";
import { AppService } from '../../services/services';
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import {IMyDefaultMonth, INgxMyDpOptions } from '@mksasi/ngx-mydatepicker';
import { NgxUiLoaderModule, NgxUiLoaderService } from "ngx-ui-loader";
import { EmailValidator, FormBuilder, FormControl, Validators } from '@angular/forms';
import { FileUploadComponent } from "src/app/common/file-upload/file-upload.component";
import { ErrorModalComponent } from "src/app/common/error-modal/error-modal.component";
import { ValidationService } from "src/app/validators/validation.service";
import { EncryptionService } from "src/app/services/encryption.service";

@Component({
  selector: 'app-ocipio',
  templateUrl: './ocipio.component.html',
  styleUrls: ['./ocipio.component.scss']
})

export class OCIPIOComponent implements OnInit {
  @ViewChild('pioociimg') FileUploadComponent: FileUploadComponent;
  @ViewChild('pioocibackimg') FileUploadComponent1: FileUploadComponent;
  docTypeList: any = [];
  docType: any = '';
  pioocibackImgempty: boolean = false;
  pioocibackUpdt: boolean = false;
  pioociImgempty: boolean = false;
  pioociUpdt: boolean = false;
  docError: boolean = false;
  getdocID: boolean;
  frontimg: any;
  backimg: any;
  erefNo: any;
  isDropdownDisabled: boolean = true;
  changeIDs: string | number;
  countryList: any;
  countryName :any;
  OCIForm = this.formBuilder.group({
    'CardNo': ['', [Validators.required]],
    // 'Country': ['', [Validators.required]],
  });
  options2:INgxMyDpOptions = {
      dateFormat: 'dd/mm/yyyy',
    };
     defaultMonth: IMyDefaultMonth;
     lastArrivalDt: any;
     arrivalDateError: boolean = false;
     lastArrivalDate: any = '';
     expiryDateError: boolean = false;
     prevsixMonthDate:any;
  sixMonthDate:any;
  ExpiryDate: any;
  @ViewChild('errorComp') errorComp: ErrorModalComponent;
  constructor(public _http: AppService, private router: Router, private http: EncryptionService, public formBuilder: FormBuilder, private toastr: ToastrService, private loader: NgxUiLoaderService) {
    this._http.getRefNum().subscribe(data => {
      this.erefNo = data;
    });

    // this._http.getStatus().subscribe(d => {
    //   if (d.PIOOCIType === 'P') {
    //     this.docType = "3";
    //   } else if (d.PIOOCIType === 'O') {
    //     this.docType = "2" ;
    //   }
    //   console.log("id:",this.docType);
    // })

  }

  ngOnInit() {
    this._http.scroll();
    this._http.getMasters().subscribe(data => {
      if (data && data.OccupationList) {
        data.DocumentTypeList.forEach((e: any) => {
          if (e.OCI) {
            this.docTypeList.push(e);
          }
        });
         this.docTypeList = this.docTypeList.filter(
        (item: { DocumentTypeId: any; }, index: any, self: any[]) =>
          index === self.findIndex((t: { DocumentTypeId: any; }) => t.DocumentTypeId === item.DocumentTypeId)
      );

        if (!this.getdocID) {
          this._http.getStatus().subscribe(data => {
            if (data.PIOOCIType === "P") {
              this.docTypeList = this.docTypeList.filter((data: any) => {
                return data.DocumentTypeId !== 2;
              })
            }
            // else{
            //   this.docTypeList = this.docTypeList.filter((data:any) => {
            //     return data.DocumentTypeId !== 3;
            //   })
            // }
            this.docTypeList.forEach((e: any) => {
              if (e.Name.charAt(0) === data.PIOOCIType) {
                this.docType = e.DocumentTypeId
              }
            })
          })
        }
      }
    });
     const today = new Date();
    const disableDate = new Date();
    disableDate.setDate(today.getDate() + 60);
    this.options2 = {
      dateFormat: 'dd/mm/yyyy',
      showTodayBtn: false,
      disableUntil: { 
        year: disableDate.getFullYear(), 
        month: disableDate.getMonth() + 1, 
        day: disableDate.getDate()  
      }
    }
    this.defaultMonth = {
      defMonth: `${disableDate.getMonth() + 1}/${disableDate.getFullYear()}`
    };
    let month:any = this.defaultMonth.defMonth.split('/');
    if (Number(month[0]) < 10) {
      month = '0' + month[0];
    }
    this.defaultMonth.defMonth = `${month}/${disableDate.getFullYear()}`;
    this.countryList = this._http.countryList;
    this.getOCIAddressInfo()


  }
  getCountryName(){
    // let a:any = this.OCIForm.controls.Country.value;
    // let c = parseInt(a);
    // let name = this.countryList.filter((e:any)=>{
    //   return e.Id === c;
    // })
    // this.OCIForm.controls['Country'].setValue( name[0].Name);
    // this.countryName = name[0].Name;
    // this.countryName = this.OCIForm.controls.Country.value;
    // if (this.countryName.toLowerCase() === "india") {
    //   this.showIndianNumber = true;
    // } else {
    //   this.showIndianNumber = false;
    // }
  }
  imageremove() {
    this.FileUploadComponent.image = "";
    this.FileUploadComponent.docTypeID = 2;
    this.FileUploadComponent1.image = "";
    this.FileUploadComponent1.docTypeID = 2;
  }
  overallStatus() {
    let url = 'DIY/DIYOverallStatus';
    this.loader.start();
    let checkSum = this.erefNo;
    let params = {
      'ReferenceNumber': this.erefNo,
    }
    this._http.httpPost(url, params, checkSum).subscribe({
      next: (data: any) => {
        this.loader.stop();
        if (data && data.IsSuccess) {
          let item = data.overallLists;
        }

      },
      error: _error => {
        this.loader.stop();
        // this.toastr.error(_error.error.Message)
        this.errorComp.ModalShow(_error.error.Message);
      }
    })
  }

  imageURL(event: any) {

    console.log(event.name);

    if (event.name === "PIOOCI" && event.url) {
      this.pioociUpdt = true;
      this.frontimg = event.url;
      this._http.setImageURLFront({
        frontimage: this.frontimg,
      })
      // console.log("front image" + this.frontimg);

      this.pioociImgempty = false;
    } else {
      this.pioocibackUpdt = true;
      this.pioocibackImgempty = false;
      this.backimg = event.url;
      this._http.setImageURLBack({
        backimage: this.backimg,
      })
      // console.log("this.backimg" + this.backimg);

    }

  }
  getOCIAddressInfo(){
    let url = "DIY/DIYGetPIOOCIInfo";
    let checkSum = this.erefNo;
    let params = {
      "ReferenceNumber": this.erefNo
    }
    this.loader.start();
    this._http.httpPost(url, params, checkSum).subscribe({
      next: (data:any)=>{
        this.loader.stop();
        let val=this.http.decryptUsingAES256(data.OutPut)
        if(val && val.IsSuccess){
          this.OCIForm.patchValue({
            'CardNo': val.ProofNo,
            // 'Country': val.IssuingCountry,
         });
           if(val.ExpairyDate){
            let a = val.ExpairyDate.split(' ');
            let d = a[0].split('/'); 
            this.lastArrivalDate = a[0];
            this.lastArrivalDt = { date: { year: d[2], month: parseInt(d[1]), day: parseInt(d[0]) } };
          }
        //  this.countryName = this.OCIForm.controls.Country.value;
        //  this.OCIForm.controls['Country'].setValue(this.countryName);
        }
       
      },error: _error=>{
        this.loader.stop();
        // this.toastr.error(_error.error.Message);
        this.errorComp.ModalShow(_error.error.Message);
      }
    })
}
  clearUploadedDocuments(event: any) {
    //  console.log(event.urldata)

    this.backimg = "";
    this.frontimg = "";
    console.log("this.backimg: " + this.backimg);
    console.log("this.frontimg: " + this.frontimg);


    this.pioociUpdt = false;
    this.pioociImgempty = false;
    this.pioocibackUpdt = false;
    this.pioocibackImgempty = false;
  }


  typeError(event: boolean) {
    this.docError = event;
  }

  getID(id: any) {
    this.docType = id;
    this.getdocID = true;
  }

  backStage() {
    this.router.navigate(['/passport'], { replaceUrl: true });
  }

  stageValidate() {
    if (!this.pioociUpdt || (this.frontimg === "" || this.frontimg === null || this.frontimg === undefined)) {
      this.pioociImgempty = true;
      // this.toastr.error('Please upload your OCI or PIO Card front image');
      this.errorComp.ModalShow('Please upload your OCI or PIO Card front image');
      return;
    }
    if (!this.pioocibackUpdt || (this.backimg === "" || this.backimg === null || this.backimg === undefined)) {
      this.pioocibackImgempty = true;
      // this.toastr.error('Please upload your OCI or PIO Card back image');
      this.errorComp.ModalShow('Please upload your OCI or PIO Card back image');
      return;
    }else if (!this.OCIForm.controls.CardNo.value) {
      this.errorComp.ModalShow('Please enter your Card No');
      return;
    }else if(!this.lastArrivalDate &&this.docType === 1037){
     this.errorComp.ModalShow('Please enter your Expiry Date');
      return;
    }
    // else if (!this.OCIForm.controls.Country.value) {
    //   this.errorComp.ModalShow('Please enter your Issuing Country');
    //   return;
    // }  
    else if (this.OCIForm.valid) {
      this.loader.start();
      let checkSum = this.erefNo;
      const params = {
        "ReferenceNumber": this.erefNo,
        "ProofNo": this.OCIForm.controls.CardNo.value,
        "ExpairyDate": this.lastArrivalDate,
        // "IssuingCountry": this.countryName,
      }

      let url = "DIY/DIYUpdatePIOOCI";
      this._http.httpPost(url, params, checkSum).subscribe({
        next: (data: any) => {
          this.loader.stop();
          let val = this.http.decryptUsingAES256(data.OutPut)
          if (val && val.IsSuccess) {
            let a = this._http.getStatus().subscribe(data => {
              if (data.Mariner) {
                this.router.navigate(['/address'], { replaceUrl: true });
              } else {
                this.router.navigate(['/foreign-address'], { replaceUrl: true });
              }
            })
            a.unsubscribe();
          } else {
            // this.toastr.error("Please try again.");
            this.errorComp.ModalShow(val.Error);
          }
        },
        error: error => {
          this.loader.stop();
          if (!window.navigator.onLine) {
            // this.toastr.error("It appears that your internet connectivity is slow or please try again.")
            this.errorComp.ModalShow("It appears that your internet connectivity is slow or please try again.");
          } else {
            // this.toastr.error(error.error.Message);
            this.errorComp.ModalShow(error.error.Message);
          }
        }
      });
    }
    // this._http.setImageURL({
    //   frontimage:this.frontimg,
    //   backimage:this.backimg
    // })

    // else{
    // this.router.navigate(['/foreign-address'], { replaceUrl: true });
    // }
  }
  docTypeCheck(e: any, get: boolean) {
    let b = parseInt(e);
    let a = this.docTypeList.filter((e: any) => {
      return e.DocumentTypeId === b;
    })

    if (get) {

      this.changeIDs = b;
      this.docType = b;
    }

  }
  checkType(event: any) {
    this.docTypeCheck(event.target.value, true);
  }
  onDateChanged(event:any){
    this.lastArrivalDate = '';
    this.ExpiryDate = event.formatted;
    let e = this.ExpiryDate.split('/')
    let a = e[2]+'-'+e[1]+'-'+e[0];
    let d = new Date();
    let requiredDate= d.setDate(d.getDate() + 15);
    this.sixMonthDate = new Date(requiredDate);
    let selectedDate = new Date(a);
    if(this.sixMonthDate.getTime() > selectedDate.getTime())
    {
      this.expiryDateError = true;
    }else{
      this.expiryDateError = false;
    }
  }

  onDateArrival(event: any) {
    this.ExpiryDate = '';
    this.lastArrivalDate = event.formatted;
    
    // Convert the selected date to a proper Date object
    let e = this.lastArrivalDate.split('/');
    let formattedDate = `${e[2]}-${e[1]}-${e[0]}`;
    let selectedDate = new Date(formattedDate);

    // Get the current date and calculate the date 60 days ago
    let today = new Date();
    let sixtyDaysAgo = new Date(today.setDate(today.getDate() - 60));

    // Check if the selected date is more than 60 days before today
    if (selectedDate.getTime() < sixtyDaysAgo.getTime()) {
        this.arrivalDateError = true;
    } else {
        this.arrivalDateError = false;
    }
}
}